"use client";

import { useSyncExternalStore } from "react";

import {
  DEFAULT_THEME,
  getResolvedTheme,
  setStoredTheme,
  subscribeTheme,
  type ThemeMode,
} from "@/lib/theme";

function getServerTheme(): ThemeMode {
  return DEFAULT_THEME;
}

export function useThemeToggle() {

  const theme = useSyncExternalStore(
    subscribeTheme,
    getResolvedTheme,
    getServerTheme,
  );

  function toggle() {
    const next: ThemeMode = theme === "dark" ? "light" : "dark";
    setStoredTheme(next);

    void fetch("/api/member/preferences", {
      method: "PATCH",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ theme: next }),
    }).catch(() => {});
  }

  return { theme, toggle };
}
